import { usePartner } from "@justhome/common/hooks";
import { FC } from "react";
import { BudgetCheckFormValues } from "../../lib/budgetCheck/types";
import useBudgetCheckContext from "../../lib/hooks/useBudgetCheckContext";
import usePostBudgetCheckWithLead from "../../lib/hooks/usePostBudgetCheckWithLead";
import { useTranslation } from "../../lib/hooks/useTranslations";
import EmbedLayout from "../EmbedLayout";
import { FormStepComponent } from "../FormSteps";
import LeadWallBudgetFirstStep from "../LeadWallFirstStep";

const EmbeddedBudgetCheckLeadWall: FC<
  FormStepComponent<BudgetCheckFormValues>
> = ({ currentStepNumber, numberOfSteps, value, onPrevious, onNext, step }) => {
  const { state, dispatch } = useBudgetCheckContext();
  const { locale } = useTranslation();
  const { partner } = usePartner();
  const { isError, isLoading, handleSubmit } = usePostBudgetCheckWithLead({
    locale,
    budgetCheckForm: value as BudgetCheckFormValues,
    onSuccess: (maximumBudget, lead) => {
      dispatch({ type: "SET_LEAD", lead });
      dispatch({ type: "SET_MAXIMUM_BUDGET", maximumBudget });
      onNext();
    },
    leadCreationAction: "MAXIMUM_BUDGET_CONTACT_WALL",
    partnerId: partner?.id,
  });

  return (
    <EmbedLayout>
      <EmbedLayout.Body
        currentStepNumber={currentStepNumber}
        numberOfSteps={numberOfSteps}
        state={currentStepNumber}
      >
        <LeadWallBudgetFirstStep
          onSubmit={handleSubmit}
          isError={isError}
          isLoading={isLoading}
          defaultValues={state.lead}
          onPrevious={onPrevious}
          hasExplicitOptIn={step.config.hasExplicitOptIn}
        />
      </EmbedLayout.Body>
    </EmbedLayout>
  );
};

export default EmbeddedBudgetCheckLeadWall;
